import React from 'react';
import styled from 'styled-components';

export type StatusType = 'success' | 'warning' | 'error' | 'default';

interface BadgeProps {
  statusType: StatusType;
}

const BadgeContainer = styled.span<BadgeProps>`
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.625rem;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  width: fit-content;

  ${(props) => {
    switch (props.statusType) {
      case 'success':
        return `
          background-color: ${props.theme.colors.successBg};
          color: ${props.theme.colors.success};
          border: 1px solid rgba(22, 163, 74, 0.2);
        `;
      case 'warning':
        return `
          background-color: ${props.theme.colors.warningBg};
          color: ${props.theme.colors.warning};
          border: 1px solid rgba(217, 119, 6, 0.2);
        `;
      case 'error':
        return `
          background-color: ${props.theme.colors.errorBg};
          color: ${props.theme.colors.error};
          border: 1px solid rgba(220, 38, 38, 0.2);
        `;
      default:
        return `
          background-color: ${props.theme.colors.surface};
          color: ${props.theme.colors.textMuted};
          border: 1px solid ${props.theme.colors.border};
        `;
    }
  }}
`;

interface StatusBadgeProps {
  status: string;
}

const getStatusType = (status: string): StatusType => {
  const lowerStatus = status.toLowerCase();
  
  if (lowerStatus.includes('ativo') || lowerStatus.includes('sucesso') || lowerStatus.includes('envasado')) {
    return 'success';
  }
  if (lowerStatus.includes('bloqueado') || lowerStatus.includes('erro') || lowerStatus.includes('cancelado')) {
    return 'error';
  }
  if (lowerStatus.includes('atenção') || lowerStatus.includes('pendente') || lowerStatus.includes('aviso')) {
    return 'warning';
  }
  
  return 'default';
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  if (!status) return null;

  return (
    <BadgeContainer statusType={getStatusType(status)}>
      {status}
    </BadgeContainer>
  );
};

export default StatusBadge;
